import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';

export const CustomerAcceptance = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <WebLayout>
      <div className="bg-[#26C4FF] p-6 md:p-12 mt-8 mb-8 md:px-40 text-white text-center">
        <h1 className="text-4xl md:text-7xl font-black">Customer Acceptance Policy</h1>
        <span className="text-xl">
          Statement on Anti Money Laundering, Sanctions and Anti Bribery and Corruption
        </span>
      </div>

      <div className="max-w-5xl mx-auto p-6 space-y-10 text-gray-800">
        <section>
          <h2 className="text-2xl font-bold mb-3">1. Introduction</h2>
          <p>
            Wire24 is committed to ensuring the security and integrity of our platform by verifying
            and accepting customers based on our policies.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">2. Eligibility Criteria</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Must be at least 18 years old.</li>
            <li>Must provide valid government-issued identification.</li>
            <li>
              Must comply with Know Your Customer (KYC) and Anti-Money Laundering (AML) regulations.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">3. Verification Process</h2>
          <p>
            Customers must undergo identity verification through valid documents and authentication
            measures before accessing full services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">4. Restricted Customers</h2>
          <p>
            Wire24 does not accept customers involved in fraudulent, illegal, or high-risk financial
            activities. Accounts may be subject to suspension if flagged for non-compliance.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">5. Customer Responsibilities</h2>
          <p>
            Customers must provide accurate information, maintain security over their accounts, and
            comply with all applicable regulations.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">6. Compliance and Monitoring</h2>
          <p>
            Wire24 reserves the right to conduct routine compliance checks and audits to ensure
            adherence to regulations and policies.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">7. Contact Information</h2>
          <p>
            For any queries regarding our Customer Acceptance Policy, contact us at{' '}
            <span className="text-blue-500">support@wire24.co</span>.
          </p>
        </section>
      </div>

      <div className="bg-gray-100 p-6 mt-12 text-center text-gray-600">
        <p>Last updated on 10th February, 2025.</p>
      </div>
    </WebLayout>
  );
};
